import { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";

import frame14 from '../assets/images/Navratri.png'
import frame15 from '../assets/images/Aadi.png'
import frame16 from '../assets/images/diwali.png'
import frame17 from '../assets/images/hyderbad.png'
import frame18 from '../assets/images/Valentine.png'
import frame19 from '../assets/images/wedding.png'
import frame20 from '../assets/images/Sachin.png'
import frame21 from '../assets/images/exchange.png'

import { RWebShare } from "react-web-share";
import axios from 'axios'

import html2canvas from 'html2canvas';
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../Components/header";


const videoConstraints = {

  facingMode: 'user',
}
export default function Camera() {
  let [picture, setPicture] = useState('')

  const [frame, setFrame] = useState()
  const [file, setfile] = useState()
  const frameRef = useRef(null)
  const webcamRef = useRef(null)
  const nav = useNavigate()
  const { state } = useLocation()
  const [selectedFilter, setSelectedFilter] = useState(null);
  const img = useRef(null)
  const FACING_MODE_USER = "user";
  const FACING_MODE_ENVIRONMENT = "environment";
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);

  const handleChangeCamera = useCallback(() => {
    setFacingMode(
      prevState =>
        prevState === FACING_MODE_USER
          ? FACING_MODE_ENVIRONMENT
          : FACING_MODE_USER
    );
  }, []);

  // useEffect(()=>{
  //   console.log("call");
  //   applyFilter('moon')
  // },[img.current])

  useEffect(() => {
    if (img.current) {
      window.Caman(`#${img.current.id}`, function () {
        applyInstagramFilter(this, selectedFilter);
        this.render();
      });
    }
  }, [selectedFilter]);
  const applyFilter = (filter) => {
    setSelectedFilter(filter);
  };





  useEffect(() => {

    if (!state) nav("/")
    else if (state.frame == 14) setFrame(frame14)
    else if (state.frame == 15) setFrame(frame15)
    else if (state.frame == 16) setFrame(frame16)
    else if (state.frame == 17) setFrame(frame17)
    else if (state.frame == 18) setFrame(frame18)
    else if (state.frame == 19) setFrame(frame19)
    else if (state.frame == 20) setFrame(frame21)
    else if (state.frame == 21) setFrame(frame20)
    // else if (state.frame == 6) setFrame(frame4)
    // else if (state.frame == 7) setFrame(frame5)
    // else if (state.frame == 8) setFrame(frame6)
    // else if (state.frame == 9) setFrame(frame7)
    // else if (state.frame == 10) setFrame(frame10)
    // else if (state.frame == 11) setFrame(frame11)

  }, [state])



  const storeData = async (fileObject) => {
    console.log("enter");
    navigator.share({

      files: [file],
      text: "#makeeverydaysparkle #tanishqglamdays #tanishqjewellery",
    });
    const formData = new FormData()
    formData.append("selfie", fileObject)
    formData.append("storeCode", state.Store_Code);

    const res = await axios.post('https://celebrations.tanishq.co.in/tanishq/selfie/upload', formData)
    console.log(res);
    const formData1 = new FormData()

    const result = await axios.post('https://celebrations.tanishq.co.in/tanishq/selfie/save', { storeCode: state.Store_Code, selfieImageName: res.data.result, name: state.Name, reason: state.Reson, myFirstDiamond: state.firstTime, rsoName: state.RSO })
    // const result = await axios.post('https://script.google.com/macros/s/AKfycbyImxyHb47_HV9y0YRVnBfrnhSvEXllCrxeMXDmQ2ELN4TSlEk6FYPVSm8IIpm4gWDAbg/exec', formData)
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = URL.createObjectURL(fileObject);
    a.download = 'tanishq-selfi.png';
    a.click();

    nav("/thankyou", { state })
  }
  const shareBtn = () => {
    return <>

      <div className="py-8 flex justify-center">
        {console.log(window.navigator)}
        {window.navigator == undefined ? <RWebShare
          data={{
            text: "#makeeverydaysparkle #tanishqglamdays #tanishqjewellery",
            files: [file],
            title: "Tanishq Selfi",
            url: " "
          }}


        >
          <a

            onClick={() => storeData(file)}
            download={"Tanishq-Selfi.png"}
            className="inline-flex justify-center items-center gap-2.5 pl-[1.5625rem] pr-[1.5625rem] p-2 rounded-lg bg-[#fff9f9] text-[#0b1023] font-['Nunito'] text-xl font-bold leading-[normal]">

            Submit
          </a>
        </RWebShare> : <a
          onClick={() => {
            storeData(file);

          }

          }

          className="inline-flex justify-center items-center gap-2.5 pl-[1.5625rem] pr-[1.5625rem] p-2 rounded-lg bg-[#fff9f9] text-[#0b1023] font-['Nunito'] text-xl font-bold leading-[normal]">

          Submit
        </a>

        }

      </div>


    </>
  }
  const frameConverter = () => {
    html2canvas(frameRef.current)
      .then(function (dataUrl) {
        const filename = "TanishqSelfi.png";
        const fileObject = dataURLtoFile(dataUrl.toDataURL(), filename);
        setfile(fileObject)
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }
  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot()
    setPicture(pictureSrc)
  })


  const applyInstagramFilter = (camanInstance, filter) => {

    camanInstance.revert();
    switch (filter) {
      case 'clarendon':
        camanInstance.clarity(10);
        camanInstance.vibrance(50);
        camanInstance.brightness(15);
        break;
      case 'gingham':
        camanInstance.greyscale().contrast(5).brightness(10).sepia(20);
        break;
      case 'moon':
        camanInstance.greyscale().contrast(5).sepia(20);
        break;
      case 'lark':
        camanInstance.brightness(5);
        camanInstance.contrast(15);
        camanInstance.saturation(-30);
        break;
      case 'reyes':
        camanInstance.brightness(10);
        camanInstance.sepia(10);
        break;
      case 'juno':
        camanInstance.saturation(20);
        camanInstance.brightness(15);
        camanInstance.contrast(10);
        break;
      case 'slumber':
        camanInstance.sepia(20);
        camanInstance.vibrance(-30);
        break;
      case 'aden':
        // Simulate temperature effect
        camanInstance.colorize('#6F4E37', 20); // Adjust the color and intensity
        break;
      case 'perpetua':
        // Simulate tint effect
        camanInstance.colorize('#55A5D0', 10); // Adjust the color and intensity
        camanInstance.vibrance(50);
        break;
      case 'inkwell':
        camanInstance.greyscale().contrast(20);
        break;
      // Add more Instagram-like filters as needed
      default:
        break;
    }
  };

  return <>
    <Header />
    <div className="flex flex-col items-center flex-wrap relative justify-center ">
      {picture == '' ? (<>

        <div className="relative">
          <Webcam
            audio={false}
            mirrored={facingMode == FACING_MODE_USER ? true : false}
            forceScreenshotSourceSize={true}
            ref={webcamRef}
            screenshotQuality={1}
            videoConstraints={{ ...videoConstraints, facingMode }}
          />
          <div onClick={handleChangeCamera} className="flex cursor-pointer absolute top-3 right-5 z-50 justify-center items-center rounded-full w-14 h-14 bg-[#D1E2FC] p-2">
            <svg className="" xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
              <path d="M26.5929 15.196V15.9084C26.5914 16.3908 26.5211 16.8705 26.384 17.333C26.5208 17.631 26.5921 17.9549 26.5929 18.2827C26.5929 20.6001 22.8414 22.7941 17.6842 23.4969C17.506 23.5214 17.3436 23.6127 17.23 23.7522C17.1164 23.8918 17.0599 24.0692 17.0719 24.2487C17.084 24.4283 17.1637 24.5966 17.2949 24.7197C17.4262 24.8428 17.5992 24.9115 17.7792 24.912C17.8112 24.9136 17.8432 24.9104 17.8742 24.9025C23.9431 24.0762 28.0176 21.4169 28.0176 18.2827C27.9999 17.6989 27.8646 17.1246 27.6199 16.5942C27.3751 16.0638 27.0258 15.5883 26.5929 15.196Z" fill="#082A63" />
              <path d="M14.6629 24.1828C14.6287 24.0966 14.5774 24.0184 14.512 23.9528L11.6627 21.1036C11.5277 20.9777 11.3491 20.9092 11.1645 20.9125C10.98 20.9157 10.8039 20.9905 10.6734 21.121C10.5429 21.2515 10.4681 21.4276 10.4649 21.6121C10.4616 21.7967 10.5301 21.9753 10.656 22.1103L12.2192 23.6735C11.3852 23.6192 10.5586 23.5388 9.75397 23.4112C4.85324 22.6229 1.42463 20.5144 1.42463 18.2825C1.4255 17.9546 1.49675 17.6307 1.63358 17.3327C1.49647 16.8702 1.42611 16.3905 1.42463 15.9081V15.1958C0.991768 15.588 0.642488 16.0636 0.3977 16.5939C0.152912 17.1243 0.0176472 17.6986 0 18.2825C0 21.3217 3.74203 23.886 9.52603 24.8168C10.4625 24.9625 11.4061 25.0586 12.3527 25.1049L10.656 26.8021C10.5301 26.9371 10.4616 27.1157 10.4649 27.3002C10.4681 27.4848 10.5429 27.6609 10.6734 27.7914C10.8039 27.9219 10.98 27.9966 11.1645 27.9999C11.3491 28.0031 11.5277 27.9346 11.6627 27.8088L14.512 24.9596C14.6091 24.8582 14.6749 24.7311 14.7017 24.5934C14.7285 24.4556 14.715 24.3131 14.6629 24.1828Z" fill="#082A63" />
              <path d="M6.41058 19.47H21.6066C22.5509 19.4689 23.4561 19.0933 24.1238 18.4256C24.7915 17.7579 25.1671 16.8527 25.1682 15.9084V7.36062C25.1671 6.41637 24.7915 5.51111 24.1238 4.84342C23.4561 4.17574 22.5509 3.80014 21.6066 3.79904H20.5182C20.1212 3.80043 19.7317 3.69054 19.3939 3.48185C19.0561 3.27316 18.7836 2.974 18.6071 2.6183L18.2825 1.96905C17.9887 1.3759 17.5344 0.876995 16.9714 0.528952C16.4083 0.180909 15.759 -0.00233232 15.097 2.24119e-05H12.9202C12.2583 -0.00233232 11.6089 0.180909 11.0458 0.528952C10.4828 0.876995 10.0286 1.3759 9.73472 1.96905L9.41009 2.6183C9.23366 2.974 8.9611 3.27316 8.62332 3.48185C8.28554 3.69054 7.89604 3.80043 7.49899 3.79904H6.41058C5.46633 3.80014 4.56107 4.17574 3.89338 4.84342C3.2257 5.51111 2.8501 6.41637 2.849 7.36062V15.9084C2.8501 16.8527 3.2257 17.7579 3.89338 18.4256C4.56107 19.0933 5.46633 19.4689 6.41058 19.47ZM14.0086 5.69855C15.0887 5.69855 16.1446 6.01883 17.0426 6.6189C17.9407 7.21898 18.6407 8.07188 19.054 9.06977C19.4673 10.0676 19.5755 11.1657 19.3648 12.225C19.154 13.2844 18.6339 14.2575 17.8702 15.0212C17.1064 15.785 16.1334 16.3051 15.074 16.5158C14.0147 16.7265 12.9166 16.6184 11.9187 16.205C10.9209 15.7917 10.068 15.0917 9.46788 14.1936C8.86781 13.2956 8.54752 12.2397 8.54752 11.1596C8.54913 9.71176 9.12501 8.32364 10.1488 7.29984C11.1726 6.27603 12.5607 5.70016 14.0086 5.69855Z" fill="#082A63" />
            </svg></div>
        </div>
      </>
      ) : (<>

        {/* aspect-square */}
        <div id="frame-img" ref={frameRef} className={`mt-5 overflow-hidden  flex  items-center relative  ${state.frame == 12 ? "justify-start" : "justify-center"}`}>

          <img className={`  h-full max-w-[600px] relative w-full  z-40 `} src={frame} />

          {/* <div className={`flex absolute   ${state.frame==13?"bottom-[2%] left-[5%] font-[500] text-[white] text-[20px] italic ":""} ${(state.frame==15)&&"bottom-[2%] left-[4%] font-[500] text-[white] text-[15px] italic"} ${(state.frame==14)?"bottom-[8%] left-[7%] font-[500] text-[#843121f6] text-[15px] italic ":""}  text-[15px] font-['nuito'] z-50  justify-center`}>{state?.Name} </div> */}
          {state.frame != 20 ? (state.frame == 19 || state.frame == 17) ? <>

            <div className={` items-baseline font-[400] absolute left-[5%]  bottom-[8%]  flex  z-50`} >

              <div className={`    w-full  text-[18px]   leading-[normal]`}>  <span className={`text-[#843121f6] ${state.frame == 19 && "text-[#c1bc28f6]"} font-[600]  px-2 py-1`}>

                {state?.Name}
              </span> </div>
            </div>

            <div className={` items-baseline font-[400] absolute right-[5%]  bottom-[8%]  flex  z-50`} >

              <div className={`    w-full  text-[18px]  leading-[normal]`}>  <span className={` text-[#843121f6] ${state.frame == 19 && "text-[#c1bc28f6]"} font-[600] px-2 py-1`}>

                {String(new Date().getDate()).padStart(2, '0') + "/" + String(new Date().getMonth() + 1).padStart(2, '0') + "/" + new Date().getFullYear()}


              </span> </div>
            </div>
          </> : <><div className={` items-baseline font absolute ${(state.frame == 15 || state.frame == 16) && "bottom-[8%] left-[8%] font-[560] text-[#8e3b3b] text-[20px] italic"}   ${state.frame == 14 ? "top-[39%] left-[71%]  font-[500] text-[#252424] text-[15px] italic " : ""}  ${state.frame == 20 ? "bottom-[7%] text-center font-[600] text-[#9a1f1f] ml-3 text-[15px] italic " : ""}   ${state.frame == 18 ? "bottom-[1%] hidden left-[2%]  font-[500] text-[#252424] text-[12px] italic " : ""}   flex      z-50`} >

            <div className={`   font-['Nunito'] w-full  md:text-[15px] text-center text-[12px] leading-[normal]`}> <span className={`text-[15px] font-[500]  font-['nuito'] z-50 ${(state.frame == 16) && "text-[#252424]"}   ${state.frame == 15 ? "translate-y-[-50px]" : ""}  `}> <span className={`${state.frame == 14 && "text-[black] text-[10px]"}`}>

              {state?.Name}
            </span></span> </div>
          </div>
            <div className={` items-baseline font absolute  ${state.frame == 18 ? "bottom-[1%] left-[32%] hidden font-[500] text-[#252424] text-[12px] italic " : ""} ${(state.frame == 15 || state.frame == 16) && "bottom-[8%] right-[8%] font-[600] text-[#8e3b3b] text-[20px] italic"}   ${state.frame == 14 ? "top-[44%] left-[70%]  font-[500] text-[#252424] text-[15px] italic " : ""}  ${state.frame == 20 ? "bottom-[4%] text-center font-[600] text-[#9a1f1f] ml-2 text-[15px] italic " : ""}    flex      z-50`} >

              <div className={`   font-['Nunito'] w-full  md:text-[15px] text-center text-[12px] leading-[normal]`}> <span className={`text-[15px] font-[500]  font-['nuito'] z-50 ${(state.frame == 16) && "text-[#252424]"}   ${state.frame == 15 ? "translate-y-[-50px]" : ""} `}> <span className={`${state.frame == 14 && "text-[black] text-[10px]"}`}>


                {String(new Date().getDate()).padStart(2, '0') + "/" + String(new Date().getMonth() + 1).padStart(2, '0') + "/" + new Date().getFullYear()}


              </span></span> </div>
            </div></> :
            <div className={` items-baseline font absolute right-[10%] bottom-[10%]  flex      z-50`} >

              <div className={`   font-['Nunito'] w-full  md:text-[18px] text-[#7C583C] text-center text-[14px] leading-[normal]`}> <span className={`text-[15px] font-[500]  font-['nuito'] z-50    `}> <span className={``}>

                {state?.Name}
              </span></span> </div>
            </div>

          }



          {<img ref={img} id="main-img" className={` absolute     ${state.frame == 15 && " w-[100%] scale-[0.65] top-[-15%] bottom-[4%]"} ${state.frame == 16 && " w-[100%] scale-[0.68] top-[-10%] bottom-[4%]"}  ${state.frame == 18 && " w-[100%] scale-[0.6]  bottom-[2%] "} ${state.frame == 19 && "top-[16%]"}  ${state.frame == 20 && " w-[100%] scale-[0.53] left-[-14.3%] top-[-12%]"} ${state.frame == 17 && " w-[100%] scale-[0.55] top-[-15%] bottom-[4%]"} ${state.frame == 14 && " w-[100%] scale-[0.6] left-[-20%] top-[-15%]"}   ${state.frame == 8 ? "mb-[1rem] ml-[10rem] mt-[1.2rem]" : ""} -z-30  `} zIndex="0" src={picture} />}
        </div>

        {!file && <div className="flex flex-wrap gap-y-3 ml-5 mt-5 justify-around">
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('moon')} style={{ backgroundImage: 'linear-gradient(45deg, #a73d88, #f76468)' }}>Moon</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('lark')} style={{ backgroundImage: 'linear-gradient(45deg, #2980b9, #2c3e50)' }}>Lark</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('reyes')} style={{ backgroundImage: 'linear-gradient(45deg, #e67e22, #d35400)' }}>Reyes</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('juno')} style={{ backgroundImage: 'linear-gradient(45deg, #3498db, #3498db)' }}>Juno</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('slumber')} style={{ backgroundImage: 'linear-gradient(45deg, #673ab7, #9c27b0)' }}>Slumber</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('aden')} style={{ backgroundImage: 'linear-gradient(45deg, #6F4E37, #fbc531)' }}>Aden</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('perpetua')} style={{ backgroundImage: 'linear-gradient(45deg, #55A5D0, #5cb8d8)' }}>Perpetua</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" onClick={() => applyFilter('inkwell')} style={{ backgroundImage: 'linear-gradient(45deg, #636e72, #2d3436)' }}>Inkwell</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" style={{ backgroundImage: 'linear-gradient(45deg, #fd8d2c, #f6341e)' }} onClick={() => applyFilter('clarendon')}>Clarendon</button>
          <button className="w-16 h-16 mx-4 rounded-lg bg-red-200" style={{ backgroundImage: 'linear-gradient(45deg, #6a50a7, #b8a0e9)' }} onClick={() => applyFilter('gingham')}>Gingham</button>

        </div>}
      </>
      )}
    </div>

    {!file && <div className=" flex py-5 md:mx-[40%] mx-[10%]   z-20 bottom-10 items-center justify-around">
      <button onClick={(e) => {
        e.preventDefault()
        { !picture ? capture() : setPicture('') }
      }} className="  rounded-full min-w-[60px] min-h-[60px] flex justify-center items-center   bg-[#e7e7e7]">
        {!picture ? <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M32.2259 64.1307C49.9404 64.1307 64.3012 49.7744 64.3012 32.0654C64.3012 14.3561 49.9404 0 32.2259 0C14.5112 0 0.150574 14.3561 0.150574 32.0654C0.150574 49.7744 14.5112 64.1307 32.2259 64.1307Z" fill="#D1E2FC" />
          <rect x="16.8542" y="17" width="30" height="30" rx="15" fill="#062564" />
        </svg> : <div className="flex justify-around">
          <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
            <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M32.1505 64.1307C49.865 64.1307 64.2258 49.7744 64.2258 32.0654C64.2258 14.3561 49.865 0 32.1505 0C14.4358 0 0.0751953 14.3561 0.0751953 32.0654C0.0751953 49.7744 14.4358 64.1307 32.1505 64.1307Z" fill="#C9D8F7" />
            <path d="M15.0752 32.6181C15.0752 27.409 15.0752 24.8043 16.3485 22.9332C16.8998 22.1232 17.6081 21.4278 18.4331 20.8866C19.6576 20.0832 21.1907 19.7961 23.5378 19.6935C24.6578 19.6935 25.6222 18.8602 25.8419 17.7818C26.1714 16.1643 27.6179 15 29.2979 15H34.8525C36.5324 15 37.979 16.1643 38.3086 17.7818C38.5282 18.8602 39.4925 19.6935 40.6126 19.6935C42.9598 19.7961 44.4927 20.0832 45.7174 20.8866C46.5422 21.4278 47.2506 22.1232 47.8019 22.9332C49.0752 24.8043 49.0752 27.409 49.0752 32.6181C49.0752 37.8274 49.0752 40.4322 47.8019 42.3032C47.2506 43.1131 46.5422 43.8085 45.7174 44.3498C43.8117 45.6 41.1588 45.6 35.8529 45.6H28.2974C22.9917 45.6 20.3388 45.6 18.4331 44.3498C17.6081 43.8085 16.8998 43.1131 16.3485 42.3032C15.9889 41.7747 15.7308 41.1877 15.5456 40.5" stroke="#062564" stroke-width="2" stroke-linecap="round" />
            <path d="M36.6598 26.9222L36.1379 26.3738C33.8324 23.9499 30.0944 23.9499 27.7889 26.3738C25.4834 28.7975 25.4834 32.7274 27.7889 35.1513C30.0944 37.5752 33.8324 37.5752 36.1379 35.1513C37.1197 34.1191 37.6835 32.8138 37.829 31.4681M36.6598 26.9222L33.8276 27.5494M36.6598 26.9222V23.6307" stroke="#062564" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </div>}

      </button>
      {picture && <>
        <svg onClick={frameConverter} className=" cursor-pointer z-50" xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M32.3011 64.1307C50.0157 64.1307 64.3764 49.7744 64.3764 32.0654C64.3764 14.3561 50.0157 0 32.3011 0C14.5864 0 0.22583 14.3561 0.22583 32.0654C0.22583 49.7744 14.5864 64.1307 32.3011 64.1307Z" fill="#C9D8F7" />
          <path d="M44.1475 29.6199C43.9874 29.4593 43.8115 29.3249 43.6281 29.207L31.3214 16.9004C30.1203 15.7004 28.1732 15.6993 26.9715 16.9004C25.7715 18.1015 25.7704 20.0481 26.9715 21.2503L37.5701 31.8479L26.9179 42.5018C25.7174 43.7029 25.7168 45.6495 26.9179 46.8511C27.5194 47.4508 28.3059 47.7521 29.0924 47.751C29.8794 47.7521 30.6665 47.4508 31.2656 46.85L43.6275 34.4898C43.8115 34.3719 43.9869 34.2364 44.1475 34.0747C44.7614 33.4607 45.057 32.6531 45.0427 31.8479C45.0576 31.0437 44.7614 30.2338 44.1475 29.6199Z" fill="#062564" />
        </svg>
      </>
      }

    </div>}
    {file && shareBtn()}
  </>
}